/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Collection(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Collection',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M8.506 7.778c-1.58 0-3.08-.226-4.222-.64a5.1 5.1 0 0 1-1.272-.642v1.53c0 1.093 2.46 1.98 5.494 1.98S14 9.12 14 8.026v-1.53a5.2 5.2 0 0 1-1.272.643c-1.143.412-2.642.637-4.222.637zm0 3.998c-1.58 0-3.08-.226-4.222-.64-.506-.182-.933-.396-1.272-.64v1.524c0 1.093 2.46 1.98 5.494 1.98S14 13.113 14 12.02v-1.524a5.2 5.2 0 0 1-1.272.64c-1.143.415-2.642.64-4.222.64M8.506 1c-3.035 0-5.494.887-5.494 1.98v1.055c0 1.094 2.46 1.978 5.494 1.978S14 5.13 14 4.035V2.98C14 1.887 11.54 1 8.506 1"}))
}
